import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEmail2"><Path d="M2 6.88197V4H22V6.88197L12 11.882L2 6.88197Z" fill="currentColor"/><Path d="M2 9.11804V20H22V9.11804L12 14.118L2 9.11804Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2;
